import Model, { attr, hasMany, type AsyncHasMany } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type IdeaModel from './idea';

export default class GroupModel extends Model {
  declare [Type]: 'group';
  @attr('string') declare title: string;
  @hasMany('idea', {
    async: true,
    inverse: 'group',
  })
  declare ideas: AsyncHasMany<IdeaModel>;
}
